import { FileUtils } from '../../utils'

export const formatBytes = (bytes: number, decimals?: number): string => {
  if (isNaN(bytes) || bytes < 1) {
    return "-";
  }
  return FileUtils.formatBytes(bytes);
};

const fileRegex = /^(.*),z([\d]+)\.PDF$/i;

export const fileSorter = (a: any, b: any): number => {
  const f1: string = a?.Filename ?? "";
  const f2: string = b?.Filename ?? "";
  const m1 = fileRegex.exec(f1) || [];
  const m2 = fileRegex.exec(f2) || [];
  let diff = 0;
  if (m1.length === 3 && m2.length === 3) {
    diff = m1[1].localeCompare(m2[1]);
    if (diff === 0) {
      diff = Number(m1[2]) - Number(m2[2]);
    }
  } else {
    diff = f1.localeCompare(f2);
  }
  return diff;
};
